import { jsx } from '@emotion/react';
import { useAlertBanner } from './useAlertBanner/useAlertBanner';
import { useQueryGetCurrencies } from '../../hooks';
export const AlertBanner = (props) => {
    const { Component, data: alertBannerData } = useAlertBanner();
    const { data: currenciesData, isLoading: isLoadingCurrencies, isError: isErrorCurrencies, } = useQueryGetCurrencies();
    if (!Component ||
        isLoadingCurrencies ||
        isErrorCurrencies ||
        !alertBannerData ||
        !currenciesData) {
        return null;
    }
    const targetCurrency = currenciesData.find((c) => c.name === (alertBannerData === null || alertBannerData === void 0 ? void 0 : alertBannerData.currentAccount.currency));
    return (jsx(Component, { data: alertBannerData, currency: targetCurrency, variant: "banner", trackEvent: props.trackEvent }));
};
//# sourceMappingURL=AlertBanner.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
